import yup, { integerPositiveValidator } from '~/utils/validators.yup';

export const conditionAfterDetailRule = {
    conditionAfterDetail: yup.object().shape({
        conditionAfterModifiedDvValue: integerPositiveValidator.required(),
        conditionAfterModifiedAttackValue: integerPositiveValidator.required(),
        conditionAfterModifiedDefenseValue: integerPositiveValidator.required(),
    }),
};
